import { TPricingOption } from './PayLinkLanding.types';
import { FormalOffer } from '../../../Seller/PayLinks/utils/Paylinks.types';
import { trackSelectedOffer } from '../../../utils/tracking';
import { CHECKOUT_BASE_PATH } from '../../Checkout/routes';
import {
  durationFromPricingOption,
  getDurationInMonths,
} from '../../utils/product';
import { buildQueryString } from '../../utils/queryParams';

export function redirectAfterPayLater({
  paymentOption,
  payLinkAmount,
  formalOffers,
  navigateToAccount,
  onAwaitDecision,
  queryParams,
  extraAccountParams,
}: {
  paymentOption: TPricingOption | null;
  payLinkAmount: number;
  formalOffers?: FormalOffer[];
  navigateToAccount: (queryString?: string) => void;
  onAwaitDecision?: () => void;
  queryParams: { payLinkId: string } & Record<string, string>;
  extraAccountParams?: Record<string, string>;
}) {
  const matchingOffer = findMatchingFormalOffer({
    paymentOption,
    formalOffers,
  });

  if (
    formalOffers &&
    matchingOffer?.offer_id &&
    (matchingOffer.available_credit ?? 0) >= payLinkAmount
  ) {
    trackSelectedOffer({
      payLinkId: queryParams.payLinkId,
      offerIds: formalOffers.map((offer) => offer.offer_id!),
      offerId: matchingOffer.offer_id,
    });

    window.location.href = `${CHECKOUT_BASE_PATH}/${buildQueryString({
      ...queryParams,
      offerId: matchingOffer.offer_id,
    })}`;
    return;
  }

  if (onAwaitDecision) {
    onAwaitDecision();
    return;
  }

  navigateToAccount(
    buildQueryString({
      ...queryParams,
      postCheckout: 'true',
      awaitDecision: 'true',
      ...extraAccountParams,
    }),
  );
}

function findMatchingFormalOffer({
  paymentOption,
  formalOffers,
}: {
  paymentOption: TPricingOption | null;
  formalOffers?: FormalOffer[];
}) {
  if (!paymentOption || !formalOffers) return undefined;

  const duration = durationFromPricingOption[paymentOption];

  return formalOffers.find(
    (offer) =>
      offer.duration && getDurationInMonths(offer.duration) === duration,
  );
}
